export default __webpack_public_path__ + "static/3-c09b87c2c04a87f07ddb6c2212990723.jpeg";